module.exports = __webpack_public_path__ + "img/hp-m4-blue.e8d60252.png";